var _rect, _rect2, _g, _path, _path2, _g2, _rect3, _rect4, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDaily = function SvgDaily(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_711_1718)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_711_1718)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5.81427,
    width: 33,
    height: 32.1857,
    rx: 3,
    fill: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_711_1718",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 33,
    height: 33
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5.79877,
    width: 33,
    height: 32.2012,
    rx: 3,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_711_1718)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.30273,
    y: 5.79877,
    width: 33.3771,
    height: 32.2012,
    rx: 3,
    fill: "white"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.81689C5 7.16004 6.34315 5.81689 8 5.81689H35C36.6569 5.81689 38 7.16004 38 8.81689V14.4823H5V8.81689Z",
    fill: "#3C8663"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_711_1718",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 33,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.81689C5 7.16004 6.34315 5.81689 8 5.81689H35C36.6569 5.81689 38 7.16004 38 8.81689V14.4823H5V8.81689Z",
    fill: "#52B788"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_711_1718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.67773 8.81689C3.67773 7.16004 5.02088 5.81689 6.67773 5.81689H32.6777C34.8869 5.81689 36.6777 7.60776 36.6777 9.81689V14.4823H3.67773V8.81689Z",
    fill: "#52B788"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4575,
    y: 2,
    width: 2.79663,
    height: 7.89169,
    rx: 1.39831,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.644,
    y: 2,
    width: 2.79664,
    height: 7.89169,
    rx: 1.39832,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.684 22.574H10.348C10.84 22.574 11.266 22.658 11.626 22.826C11.986 22.994 12.28 23.225 12.508 23.519C12.736 23.807 12.904 24.146 13.012 24.536C13.126 24.926 13.183 25.343 13.183 25.787C13.183 26.231 13.126 26.648 13.012 27.038C12.904 27.428 12.736 27.77 12.508 28.064C12.28 28.352 11.986 28.58 11.626 28.748C11.266 28.916 10.84 29 10.348 29H7.684V22.574ZM8.809 28.082H9.916C10.354 28.082 10.711 28.025 10.987 27.911C11.269 27.791 11.488 27.629 11.644 27.425C11.806 27.215 11.914 26.972 11.968 26.696C12.028 26.414 12.058 26.111 12.058 25.787C12.058 25.463 12.028 25.163 11.968 24.887C11.914 24.605 11.806 24.362 11.644 24.158C11.488 23.948 11.269 23.786 10.987 23.672C10.711 23.552 10.354 23.492 9.916 23.492H8.809V28.082ZM16.3981 22.574H17.5951L20.0701 29H18.8641L18.2611 27.299H15.6961L15.0931 29H13.9321L16.3981 22.574ZM16.0021 26.444H17.9641L17.0011 23.681H16.9741L16.0021 26.444ZM21.182 22.574H22.307V29H21.182V22.574ZM24.1869 22.574H25.3119V28.028H28.5789V29H24.1869V22.574ZM30.5269 26.48L28.1149 22.574H29.4199L31.1209 25.454L32.7949 22.574H34.0549L31.6519 26.48V29H30.5269V26.48Z",
    fill: "#52B788"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_711_1718",
    x: 4,
    y: 5.79877,
    width: 35,
    height: 34.2012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_711_1718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_711_1718",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_711_1718",
    x: 5,
    y: 5.79877,
    width: 35,
    height: 34.2012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.321569 0 0 0 0 0.717647 0 0 0 0 0.533333 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_711_1718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_711_1718",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDaily);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/daily.b78c9e52d143ccb056f34728188a6b76.svg";